import React from "react";
import { Button, FormControl, FormGroup, FormLabel, } from "react-bootstrap";
import { DisplayBox, InputBox, } from "../../components";
import { AccountUserInterface, ApiHelper, DepartmentInterface, UserHelper } from "../../helpers";

interface Props {
  department: DepartmentInterface
}
export const Permissions: React.FC<Props> = props => {
  const [accountUsers, setAccountUsers] = React.useState<AccountUserInterface[]>(null);
  const [showAdd, setShowAdd] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [permission, setPermission] = React.useState("");

  const init = () => {
    if (UserHelper.checkAccess("owner") || UserHelper.checkAccess("admin")) {
      ApiHelper.get("/accountUsers").then((data: DepartmentInterface[]) => setAccountUsers(data));
      //setSelectedDepartment(null);
    }
  }

  React.useEffect(init, [])


  const addPermission = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowAdd(true);
    setEmail("");
    setPermission("edit");
  }

  const getNewButton = () => {
    return <Button size="sm" variant="success" onClick={addPermission} ><i className="fas fa-user" style={{ color: "#FFF" }}></i> New</Button>
  }

  const deletePermission = (au: AccountUserInterface) => {
    if (window.confirm("Are you sure you wish to remove this user?")) ApiHelper.delete("/accountUsers/" + au.id).then(() => { init() });
  }


  const getRows = (departmentId: number) => {
    const result: JSX.Element[] = [];
    accountUsers?.forEach(au => {
      if ((departmentId === 0 && au.permissions === "owner") || au.departmentId === departmentId) {
        const accountUser = au;

        /*
        const deleteButton = (au.userId === UserHelper.user.id) ? <></>
          : <Button size="sm" variant="danger" onClick={(e) => { e.preventDefault(); deletePermission(accountUser); }} >Delete</Button>
          */
        const deleteButton = <Button size="sm" variant="danger" onClick={(e) => { e.preventDefault(); deletePermission(accountUser); }} >Delete</Button>
        if (au.user) {
          result.push(<tr>
            <td>{au?.user?.email}</td>
            <td>{au?.permissions}</td>
            <td style={{ textAlign: "right" }}>{deleteButton}</td>
          </tr>)
        }
      }
    })
    return result;
  }




  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "email": setEmail(val); break;
      case "permission": setPermission(val); break;
    }
  }

  const handleSave = () => {
    let departmentId = (permission === "owner") ? null : props.department.id;
    ApiHelper.post("/accountUsers/add", { departmentId: departmentId, email: email, permissions: permission }).then(() => {
      setShowAdd(false);
      init();
    });
  }

  const handleCancel = () => { setShowAdd(false); }


  if (showAdd) {
    return (<InputBox headerText={"Add User - " + props.department?.name} headerIcon="fas fa-user" saveFunction={handleSave} cancelFunction={handleCancel}  >
      <FormGroup>
        <FormLabel>Email</FormLabel>
        <FormControl id="email" value={email} onChange={handleChange} />
      </FormGroup>
      <FormGroup>
        <FormLabel>Permission</FormLabel>
        <FormControl as="select" id="permission" value={permission} onChange={handleChange} >
          <option value="edit" >Edit Department</option>
          <option value="owner" >Account Owner</option>
        </FormControl>
      </FormGroup>
    </InputBox>)
  } else {
    return (
      <DisplayBox headerText={props.department?.name + " Permissions"} headerIcon="fas fa-user" editContent={getNewButton()}  >
        <h4>Department Permissions</h4>
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Permissions</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {getRows(props.department.id)}
          </tbody>
        </table>
        <br />
        <hr />
        <br />
        <h4>Account Permissions</h4>
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Permissions</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {getRows(0)}
          </tbody>
        </table>
      </DisplayBox>
    );
  }

};